import { $themeColors } from "@themeConfig";
import { chartColors } from "./chartjsData";

export default {
  pieChart: {
    options: {
      responsive: true,
      maintainAspectRatio: true,
      responsiveAnimationDuration: 500,
      legend: { display: true },
      pieceLabel: {
        mode: "percentage",
        precision: 1,
      },
      tooltips: {
        callbacks: {
          label(tooltipItem, data) {
            const label = data.datasets[0].labels[tooltipItem.index] || "";
            const value = data.datasets[0].data[tooltipItem.index];
            const output = ` ${label} : ${value} %`;
            return output;
          },
        },
        // Updated default tooltip UI
        shadowOffsetX: 1,
        shadowOffsetY: 1,
        shadowBlur: 8,
        shadowColor: chartColors.tooltipShadow,
        backgroundColor: $themeColors.light,
        titleFontColor: $themeColors.dark,
        bodyFontColor: $themeColors.dark,
      },
    },
    data: {
      datasets: [
        {
          labels: [],
          data: [],
          backgroundColor: [
            "#8d5185",
            "#27ae60",
            "#2980b9",
            "#ffc107",
            "#c0392b",
          ],
          borderWidth: 0,
          pointStyle: "rectRounded",
        },
      ],
    },
  },
};
